import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CountryCode, getCountryDisplayNameByCountryCode } from '@pdqdev/pdq-shared/dist/utils/Country-utils';

import { CANADA_ADDRESS_COUNTRIES, USA_ADDRESS_COUNTRIES } from '../../../../../utils/address-utils';
import { Address } from '../../../../sharedModule/models/address.model';

@Component({
  selector: 'location-card',
  templateUrl: './location-card.component.html',
  styleUrls: ['./location-card.component.scss'],
  standalone: false,
})
export class LocationCardComponent implements OnInit, OnChanges {
  @Input() address: Address;
  @Input() isDefault: boolean = false;
  @Input() clickable: boolean = false;
  @Output() onClick = new EventEmitter();
  addressTitle: string;
  addressDescription: string;
  constructor() {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.address) {
      this.createAddressView();
    }
  }

  ngOnInit(): void {
    if (this.address) this.createAddressView();
  }

  handleLocationClick() {
    if (this.clickable) this.onClick.emit(this.address.id);
  }
  createAddressView() {
    this.addressTitle = this.address.storeName ? this.address.storeName.trim() : '';
    this.addressDescription = '';
    const descriptionElements = [];
    const subLocationElements = [];
    if (this.address.address1) {
      descriptionElements.push(this.address.address1.trim());
    }
    if (this.address.city) {
      subLocationElements.push(this.address.city.trim());
    }
    if (
      this.address.province &&
      this.address.country &&
      ((Object.values(USA_ADDRESS_COUNTRIES) as string[]).includes(this.address.country) ||
        this.address.country in CANADA_ADDRESS_COUNTRIES)
    ) {
      subLocationElements.push(this.address.province.trim());
    }
    if (this.address.zip) {
      subLocationElements.push(this.address.zip.trim());
    }
    descriptionElements.push(subLocationElements.join(' '));
    if (this.address.country) {
      descriptionElements.push(
        this.address.country in CountryCode
          ? getCountryDisplayNameByCountryCode(this.address.country)
          : this.address.country,
      );
    }

    this.addressDescription = descriptionElements.join(', ');
  }
}
